import React from "react";
import { useSelector } from "react-redux";
import MoneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const MonthToDate = () => {
  const { totalRevenueMTD, currencySymbol, totalRevenueMTDRawDataLink, totalRevenueMTMChange } =
    useSelector((state) => state.totalRevenue.allRevenues);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <MoneyDisplay
        value={totalRevenueMTD}
        currency={currencySymbol}
        url={totalRevenueMTDRawDataLink}
        size={44}
        disableAnimation={isUserQa}
      />
      <PercentChanged
        changeValue={totalRevenueMTMChange}
        currencySymbol={currencySymbol}
        toolTip="Percentage change from previous month"
        showBorder
      />
    </>
  );
};

export default MonthToDate;
